import { Box, Stack, Typography } from '@mui/material';
import color from '@theme/Colors';
import { ReactNode } from 'react';

export type ChecklistRowTone = 'success' | 'error' | 'default';

type Props = {
    icon: ReactNode;
    title: string;
    value: ReactNode;
    tone?: ChecklistRowTone;
    divider?: boolean;
};

const toneToColor: Record<ChecklistRowTone, string> = {
    success: color.success,
    error: color.danger,
    default: color.textPrimary,
};

export default function ChecklistRow(props: Props) {
    const { icon, title, value, tone = 'default', divider = true } = props;

    return (
        <Stack
            direction="row"
            alignItems="center"
            spacing={1.5}
            sx={{
                py: 1.25,
                borderBottom: divider ? `1px solid ${color.grey200}` : 'none',
            }}
        >
            <Box
                sx={{
                    width: 36,
                    height: 36,
                    flexShrink: 0,
                    borderRadius: 1,
                    bgcolor: color.grey100,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: color.grey600,
                    '& svg': { fontSize: 20 },
                }}
            >
                {icon}
            </Box>

            <Stack sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="body1" fontWeight={600} color={color.textPrimary}>
                    {title}
                </Typography>
            </Stack>

            <Box
                sx={{
                    flexShrink: 0,
                    textAlign: 'right',
                    color: toneToColor[tone],
                    fontWeight: tone === 'default' ? 500 : 600,
                    fontSize: 14,
                }}
            >
                {value}
            </Box>
        </Stack>
    );
}
